import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,
    services: {
        get_i18n_text: {
            parameters: [
                {
                    name: 'namespace',
                    type: 'string',
                    optional: false
                }
            ]
        },
        get_i18n_namespaces: {
            parameters: []
        },
        get_lpl1_text: {
            parameters: []
        }
    }
});
export default svc;
